
const _log: boolean = false;

export class CreditCardUtilities {

    /**
     * Strips just the numbers from a credit card number
     * @param card - The original string
     * @return {string} - The stripped credit card number
     */
    public static stripCardToNumbers(card : string){

        if(_log) console.group("CreditCardUtilities::stripCardToNumbers");
        if(_log) console.debug("The original credit card number");
        if(_log) console.log(card);

        if(card == null) {
            if(_log) console.warn("The card was null.");
            if(_log) console.groupEnd();
            return null;   //A quick safety
        }

        let fixed : string = card.replace(/[^0-9]/g, '');
        if(_log) console.debug("The stripped card number");
        if(_log) console.log(fixed);
        if(_log) console.groupEnd();
        return fixed;
    }

    /**
     * Checks if the card number provided is less than the maximum (which is 19)
     * @param card
     * @param strip_card
     * @return {boolean} true = okay
     *                  false = not okay
     */
    public static maxCardLengthValidate(card : string, strip_card : boolean = true){
        if(_log) console.group("CreditCardUtilities::maxCardLengthValidate");
        if(card == null){
            if(_log) console.debug("The card number is null");
            if(_log) console.log('Does not exceed max length - okay');
            if(_log) console.groupEnd();
            return true;
        }

        if(strip_card) {
            if(_log) console.debug("Stripping card number");
            card = CreditCardUtilities.stripCardToNumbers(card);
        }

        if(_log) console.debug("Checking the card number length");
        if(_log) console.log("Current length is " + card.length);
        if(card.length <= 19){
            if(_log) console.log('Does not exceed max length - okay');
            if(_log) console.groupEnd();
            return true;
        }else{
            if(_log) console.warn('DOES exceed max length - failed');
            if(_log) console.groupEnd();
            return false;
        }
    }

    /**
     * The luhn test
     * @see https://gist.github.com/DiegoSalazar/4075533
     * @param card
     * @return {boolean}
     */
    public static luhn(card : string){
        if(_log) console.group("CreditCardUtilities::luhn");
        if(card == null){
            if(_log) console.debug("The card number is null");
            if(_log) console.log('Card may never pass the Luhn test - failed');
            if(_log) console.groupEnd();
            return false;
        }

        if(_log) console.debug("Stripping card number");
        card = CreditCardUtilities.stripCardToNumbers(card);

        if(_log) console.debug("Running the Luhn algorithm");
        // The Luhn Algorithm. It's so pretty.
        var nCheck = 0, bEven = false;

        for (var n = card.length - 1; n >= 0; n--) {
            var cDigit = card.charAt(n),
                nDigit = parseInt(cDigit, 10);

            if (bEven) {
                if ((nDigit *= 2) > 9) nDigit -= 9;
            }

            nCheck += nDigit;
            bEven = !bEven;
        }

        let mod10 = nCheck % 10;
        if(_log) console.debug("Mod");
        if(_log) console.log(mod10);

        if(_log) console.debug("Checking if the card passes the Luhn test");
        let passes_mod10 = mod10 == 0;
        if(passes_mod10){
            if(_log) console.log('Passes Luhn test - okay');
            if(_log) console.groupEnd();
            return true;
        }else{
            if(_log) console.warn('Does NOT pass the Luhn test - failed');
            if(_log) console.groupEnd();
            return false;
        }
    }
}